<template>
    <div class="fluid">
        <h1 class="app-title">Gerar Requisição - Honorários De Protesto</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fas fa-id-card"
                                class="mx-auto"
                                title="Indicar o Devedor">
                            <Devedor
                                    ref="abaDevedor"
                                    :requisicao="requisicao"
                                    @atribuirDevedor="atribuirDevedor"
                            />
                        </tab-content>
                        <tab-content
                                icon="fas fa-bullhorn"
                                class="mx-auto"
                                title="Protestos Ativos e Sem Carta" >
                            <TabelaPesquisas ref="abaTabela"
                                             :requisicao="requisicao"
                                             :cdasSelecionadas="cdasSelecionadas"
                                             @prevTab="prevTab"
                                             @nextStep="nextStep"
                                             @selecionarCdas="selecionarCdas"
                                             @atribuirFiltros="atribuirFiltros"
                                             @openCloseFilterPopup="openCloseFilterPopup"
                                             @closeFilterPopup="closeFilterPopup"
                                             @obterHonorariosProtesto="obterHonorariosProtesto"
                                             @abrirExtratoCda="abrirExtratoCda" />
                        </tab-content>
                        <tab-content
                                icon="fas fa-funnel-dollar"
                                class="mx-auto"
                                title="Definir Base de Cálculo">
                            <TabelaCalculos ref="abaTabelaCalculo"
                                             :cdasSelecionadas="cdasSelecionadas"
                                             :requisicao="requisicao"
                                             @prevTab="prevTab"
                                             @nextStep="nextStep"
                                             @selecionarCdas="selecionarCdas"
                                             @atribuirFiltros="atribuirFiltros"
                                             @openCloseFilterPopup="openCloseFilterPopup"
                                             @closeFilterPopup="closeFilterPopup"
                                             @atribuirListaCda="atribuirListaCda"
                                             @abrirExtratoCda="abrirExtratoCda" />
                        </tab-content>
                        <tab-content
                                icon="fas fa-file-invoice-dollar"
                                class="mx-auto"
                                title="Confirmar Geração da Requisição">
                            <ConfirmarGeracao ref="abaConfirmar"
                                            :requisicao="requisicao"
                                            @executeUpload="executeUpload"
                                            @excluirArquivo="excluirArquivo" />
                        </tab-content>
                        <tab-content
                                icon="fas fa-money-check-alt"
                                class="mx-auto"
                                title="Requisição Gerada">
                            <Conclusao ref="abaConcluir"
                                        :requisicao="requisicao"
                                        :retornoSalvar="retornoSalvar"
                                        :nova="requisicao.codRequisicaoProtesto == null" />
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex > 2 && !props.isLastStep"
                                            @click="prevTab"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex != 1 && props.activeTabIndex != 2 && props.activeTabIndex < 3">
                                    <b-button
                                            id="btnProxima"
                                            @click="nextStep"
                                            :disabled="!validarProxima()"
                                            variant="primary">
                                        Próxima
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 4">
                                    <b-button class="finish-button" variant="success" @click="sair">
                                        Concluir
                                        <i class="fas fa-flag-checkered"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="6" class="text-right" v-if="props.activeTabIndex == 3">
                                    <b-button variant="secondary" @click="sair" class="mr-2">
                                        <i class="fas fa-sign-out-alt"></i>
                                        Sair Sem Gerar Requisição
                                    </b-button>
                                    <b-button variant="warning" @click="salvar()" :disabled="!confirmarValido">
                                        <i class="fa fa-file-pdf"></i>
                                        Confirmar Geração da Requisição
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
      <ExtratoCda
          ref="extratoCda"
          :loading="this.$refs.loading" />
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import formatarMixins from '../../mixins/formatarMixins';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import Devedor from "./components/Devedor";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import TabelaCalculos from "./components/TabelaCalculos";
    import CompLoading from "../shared/components/CompLoading";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import ConfirmarGeracao from "./components/ConfirmarGeracao";
    import Conclusao from "./components/Conclusao";
    import moment from 'moment'
    import ExtratoCda from "../shared/components/ExtratoCda";

    export default {
        mixins: [ formatarMixins ],
        components: {
          ExtratoCda,
            Devedor,
            Conclusao,
            ConfirmarGeracao,
            TabelaPesquisas,
            TabelaCalculos,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
            CompFiltroGrid
        },
        data() {
            return {
                urlApi: null,
                token: null,
                cdasSelecionadas: [],
                filtro: {
                },
                requisicao: {
                    codRequisicaoProtesto: null,
                    numeroCda: null,
                    pagamento: null,
                    numeroParcelas: null,
                    indiceReajuste: null,
                    formaPagamento: 1,
                    totalRequisicao: null,
                    emitirTermoParcelamentoHonorario: false,
                    emitirGrpr: false,
                    emitirDocumentacao: true,
                    emailEnviarDocumentacao: null,
                    setor: null,
                    observacoes: null,
                    houveAlteracao: false,
                    arquivos: [],
                    devedor: {
                        codContribuinte: null,
                        documento: null,
                        nome: null
                    },
                    cdas: []
                },
                retornoSalvar: {
                    id: null,
                    arquivo: null
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
            confirmarValido() {
                return !this.verificarValorVazio(this.requisicao.setor) &&
                        this.$refs.abaConfirmar.validarObservacao() && this.$refs.abaConfirmar.validarEmailPreenchido();
            },
        },
        methods: {
            atribuirDevedor(devedor) {
                if(devedor == null) {
                    this.requisicao.devedor = {
                        codContribuinte: null,
                        documento: null,
                        nome: null
                    };
                } else {
                    this.requisicao.devedor = devedor;
                }
            },
            validarProxima() {
                if(this.$refs.wizard != null && this.$refs.wizard.activeTabIndex == 0
                    && (this.$refs.abaDevedor == null || !this.$refs.abaDevedor.validarForm())) {
                    return false;
                }

                return true;
            },
            acionarEnter(e) {
                if(e.key == 'Enter') {
                    if(this.$refs.wizard.activeTabIndex == 0 && this.$refs.abaDevedor != null && this.$refs.abaDevedor.validarForm()) {
                        document.getElementById("btnProxima").click();
                    } else if(this.$refs.wizard.activeTabIndex == 1 && this.cdasSelecionadas.length > 0) {
                        document.getElementById("btnProximaTabela").click();
                    } else if(this.$refs.wizard.activeTabIndex == 2 && this.requisicao.cdas.length > 0) {
                        document.getElementById("btnProximaCalculos").click();
                    }
                }
            },
            acionarEnterDelay(e) {
                if(!this.$refs.abaDevedor.modalOpen() && e.key == 'Enter' && e.path == undefined || e.path[0].type == undefined || e.path[0].type != 'button') {
                    setTimeout(()=>{
                        this.acionarEnter(e);
                    }, 200);
                }
            },
            selecionarCdas(cdas) {
                this.cdasSelecionadas = cdas;
            },
            atribuirFiltros(filtros) {
                this.filtro = filtros;
            },
            openCloseFilterPopup(event) {
                this.$refs.compFiltro.openCloseFilterPopup(event);
            },
            closeFilterPopup() {
                this.$refs.compFiltro.closeFilterPopup();
            },
            filtrarResultados(limpar) {
                if(this.$refs.wizard.activeTabIndex == 1) {
                    this.$refs.abaTabela.filtrarResultados(limpar);
                } else if(this.$refs.wizard.activeTabIndex == 2) {
                    this.$refs.abaTabelaCalculo.filtrarResultados(limpar);
                }
            },
            ordenarResultados(order) {
                if(this.$refs.wizard.activeTabIndex == 1) {
                    this.$refs.abaTabela.ordenarResultados(order);
                } else if(this.$refs.wizard.activeTabIndex == 2) {
                    this.$refs.abaTabelaCalculo.ordenarResultados(order);
                }
            },
            nextStep() {
                this.$store.commit("setMessages", {});
                if(this.$refs.wizard.activeTabIndex == 0) {
                    this.$refs.wizard.nextTab();
                    this.cdasSelecionadas = [];
                    this.$refs.abaTabela.pesquisaInicial = true;
                    this.$refs.abaTabela.limparFiltros();

                    this.requisicao.numeroParcelas = null;
                    this.requisicao.indiceReajuste = null;
                    this.requisicao.setor = null;
                    this.requisicao.observacoes = null;
                    this.requisicao.emailEnviarDocumentacao = null;
                    this.requisicao.houveAlteracao = false;

                    this.$refs.abaTabelaCalculo.atribuirRegraPagamento();
                    this.$refs.abaConfirmar.atribuirSetorPadrao();
                } else if(this.$refs.wizard.activeTabIndex == 1) {
                    this.$refs.wizard.nextTab();
                    this.$refs.abaTabelaCalculo.limparFiltros(true);
                } else if(this.$refs.wizard.activeTabIndex == 2 && this.$refs.abaTabelaCalculo.validarProximo()) {
                    this.$refs.abaTabelaCalculo.fecharRecalcular();

                    if(this.requisicao.pagamento.parcelas) {
                        this.requisicao.emitirTermoParcelamentoHonorario = true;
                    } else {
                        this.requisicao.emitirTermoParcelamentoHonorario = false;
                    }
                    if(this.requisicao.pagamento.refis) {
                        this.requisicao.emitirGrpr = false;
                    }
                    if(this.requisicao.emailEnviarDocumentacao == null) {
                        this.requisicao.emailEnviarDocumentacao = this.adicionarEmailDevedor(this.requisicao.devedor, null);
                    }
                    this.$refs.abaConfirmar.atualizarSetor();
                    this.$refs.wizard.nextTab();
                }
                window.scrollTo(0,0);
            },
            prevTab() {
                this.$store.commit("setMessages", {});

                if(this.$refs.wizard.activeTabIndex == 2) {
                    this.$refs.abaTabela.consultar();
                }
                this.$refs.wizard.prevTab();
            },
            atribuirListaCda(items) {
                this.requisicao.cdas = items;
            },
            adicionarEmailDevedor(devedor, emails) {
                if(devedor.email != null && devedor.email != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.email;
                }
                if(devedor.emailAlternativo1 != null && devedor.emailAlternativo1 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo1;
                }
                if(devedor.emailAlternativo2 != null && devedor.emailAlternativo2 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo2;
                }
                return emails;
            },
            executeUpload(arquivoConvertido) {
                this.requisicao.arquivos.push(arquivoConvertido);
            },
            limparAnexos() {
                this.requisicao.arquivos = [];
            },
            excluirArquivo(arquivo) {
                const index = this.requisicao.arquivos.indexOf(arquivo);
                this.requisicao.arquivos.splice(index, 1);
            },
            async voltar() {
                this.$refs.wizard.reset();
            },
            sair() {
                this.$router.push({path: '/honorarios'});
            },
            async salvar() {
                this.$store.commit("setMessages", {});

                if(this.verificarValorVazio(this.requisicao.setor)) {
                    this.exibirMensagem('Favor preencher os campos obrigatórios (*)');
                    return;
                }

                if(this.$refs.abaConfirmar.validarObservacao() && this.$refs.abaConfirmar.validarEmailPreenchido()) {
                    this.finalizarConfirmar();
                }
            },

            async finalizarConfirmar() {
                let filterItems = [];
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if(!this.requisicao.pagamento.refis || this.requisicao.cdas[i].refisAtivo == 'S') {
                        filterItems.push(this.requisicao.cdas[i]);
                    }
                }

                let requisicaoTemp = {
                    ... this.requisicao,
                    cdas: filterItems
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosProtesto/salvar`, requisicaoTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.retornoSalvar = response.data;
                    this.$refs.wizard.nextTab();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            async obterHonorariosProtesto(id, avancarDois) {
                this.$refs.loading.showLoading();
                await axios.get(`${this.urlApi}/v1/honorariosProtesto/obter/` + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.requisicao = {
                        ...response.data
                    };

                    this.$refs.wizard.nextTab();

                    if(avancarDois) {
                        this.$refs.wizard.nextTab();
                    }

                    this.cdasSelecionadas = [];
                    for(let i = 0; i < this.requisicao.cdas.length; i++) {
                        this.cdasSelecionadas.push({
                            codCdaSefa: this.requisicao.cdas[i].codCdaSefa
                        });
                    }

                    setTimeout(()=>{
                        this.$refs.abaTabelaCalculo.iniciarSubListaFitltro();
                        for(let i = 0; i < this.requisicao.cdas.length; i++) {
                            this.$refs.abaTabelaCalculo.calcularValorBaseHonorarios(this.requisicao.cdas[i]);
                            this.$refs.abaTabelaCalculo.atribuirPagamentoRequisicao();
                        }
                    }, 200);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },
            abrirExtratoCda(numeroCda) {
              this.$refs['extratoCda'].abrirExtrato(numeroCda);
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let honorariosProtesto = this.$store.getters.getHonorariosProtesto;
            if(honorariosProtesto) {
                this.$store.commit('setHonorariosProtesto', null);
                this.obterHonorariosProtesto(honorariosProtesto, true);
            }
            
            setTimeout(()=>{
                document.getElementsByClassName('cpfCnpj')[0].focus();
                window.addEventListener("keypress", this.acionarEnterDelay);
            }, 500);
        },
    }
</script>
